import { createSlice } from "@reduxjs/toolkit";
import { loginThunk, autoLoginThunk } from "./authThunk";
import { clearToken } from "./authHelpers";

const initialState = {
  status: "idle",   // "idle" | "loading" | "succeeded" | "failed"
  error: null,
  user: null,       // null instead of empty string
  message: "",      // renamed from success
};

const authSlice = createSlice({
  name: "authentication",
  initialState,
  reducers: {
    logout: (state) => {
      state.status = "idle";
      state.error = null;
      state.user = null;
      state.message = "";
      clearToken();
    },
  },
  extraReducers: (builder) => {
    builder
      // 🔹 Login
      .addCase(loginThunk.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(loginThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.message; // renamed
        state.user = action.payload.user;
        state.error = null;
      })
      .addCase(loginThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload?.message || "Login failed";
        state.user = null;
        state.message = "";
      })

      // 🔹 AutoLogin
      .addCase(autoLoginThunk.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(autoLoginThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.message;
        state.user = action.payload.user;
        state.error = null;
      })
      .addCase(autoLoginThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload?.message || "Session refresh failed";
        state.user = null;
        state.message = "";
        clearToken();
      });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
